export const SUPPORT_MAILING_ADDRESS = 'incoming+knotty-node-development-living-ledger-frontend-10776473-issue-@incoming.gitlab.com';